import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
}

const KlubExclusiveIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#fff",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 240 48"
    >
      <g clipPath="url(#klubExclusiveIcon-a)">
        <path
          fill="url(#klubExclusiveIcon-b)"
          d="M0 3.997a4 4 0 0 1 3.997-4C19.6-.01 35.203 0 50.806 0 64.72-.001 76 10.744 76 23.999s-11.28 24-25.194 24H4a4 4 0 0 1-4-4V3.997Z"
        />
        <path
          fill="#F8F9EF"
          d="M23.708 32.292h1.717l-2.775 3.15 2.734 4.43h-1.886L21.497 36.7l-.733.795v2.378H19.16v-7.584h1.603v3.247l2.944-3.247v.003ZM31.387 38.512v1.36h-4.86V32.29h1.613v6.22h3.247v.003ZM36.487 36.91v-4.617H38.1v4.85c0 2.011-1.162 2.859-3.059 2.859-2.093 0-2.985-.922-2.985-2.9v-4.806h1.625v4.587c0 1.183.302 1.77 1.425 1.77 1.124 0 1.383-.502 1.383-1.74l-.003-.002ZM39.415 32.293h3.007c1.79 0 2.292.818 2.292 1.854 0 1.035-.67 1.559-1.433 1.769v.022c1.204.147 1.758.806 1.758 1.853 0 1.551-1.216 2.085-2.86 2.085h-2.764v-7.583Zm3.718 2.115c0-.818-.545-.87-1.267-.87h-.837v1.887h.597c.755 0 1.507-.136 1.507-1.017Zm.188 3.236c0-.848-.586-.995-1.308-.995h-.984v1.979h.829c.88 0 1.466-.158 1.466-.984h-.003ZM42.912 18.555a6.02 6.02 0 0 0 2-4.482c0-3.355-2.76-6.073-6.166-6.073-1.496 0-2.87.526-3.939 1.401l-.005.006c-.044.035-1.486 1.319-2.846 2.532a952.358 952.358 0 0 0-2.846-2.532l-.005-.006A6.193 6.193 0 0 0 25.166 8C21.761 8 19 10.72 19 14.073c0 1.775.771 3.37 2 4.482a6.02 6.02 0 0 0-2 4.48c0 3.357 2.761 6.074 6.166 6.074 1.497 0 2.87-.526 3.939-1.4l.005-.006c.044-.036 1.486-1.32 2.846-2.533a944.995 944.995 0 0 0 2.846 2.533l.005.005a6.194 6.194 0 0 0 3.94 1.401c3.404 0 6.165-2.72 6.165-6.073 0-1.775-.771-3.37-2-4.481Zm-17.74-7.366c.877 0 1.507.352 1.886.655.215.19 1.276 1.133 2.505 2.23l-2.505 2.229a2.984 2.984 0 0 1-1.887.654c-1.64 0-2.973-1.295-2.973-2.884s1.335-2.884 2.973-2.884Zm1.886 14.074a2.984 2.984 0 0 1-1.887.654c-1.64 0-2.973-1.295-2.973-2.884s1.335-2.884 2.973-2.884a3 3 0 0 1 1.887.654c.215.191 1.276 1.134 2.505 2.23-1.227 1.093-2.29 2.04-2.505 2.23Zm2.27-6.708c.456-.404 1.568-1.396 2.634-2.345l2.396-2.137c1.23-1.093 2.29-2.039 2.505-2.23a2.984 2.984 0 0 1 1.886-.654c1.641 0 2.974 1.295 2.974 2.884 0 1.59-1.336 2.884-2.974 2.884a6.2 6.2 0 0 0-3.939 1.401l-.005.006-.213.188-2.633 2.344c-1.063-.948-2.175-1.938-2.633-2.344l.002.003Zm9.421 7.365a3 3 0 0 1-1.886-.654c-.215-.191-1.276-1.134-2.505-2.23 1.226-1.093 2.29-2.039 2.505-2.23a2.984 2.984 0 0 1 1.886-.654c1.641 0 2.974 1.295 2.974 2.884 0 1.59-1.336 2.884-2.974 2.884Z"
        />
        <path
          fill="#F8F9EF"
          d="m29.56 14.087 2.404-2.129c-1.357-1.216-2.794-2.505-2.837-2.54l-.006-.006A6.187 6.187 0 0 0 25.188 8c-3.405-.01-6.174 2.701-6.183 6.057a6.019 6.019 0 0 0 1.988 4.487 6.186 6.186 0 0 1 4.168-1.581h.01c-1.64 0-2.974-1.295-2.974-2.884 0-1.59 1.336-2.884 2.974-2.884.878 0 1.508.351 1.887.654.215.19 1.275 1.134 2.505 2.23M29.563 23.022a2097.16 2097.16 0 0 1-2.505 2.23 2.984 2.984 0 0 1-1.887.654c-1.64 0-2.974-1.295-2.974-2.884 0-1.59 1.336-2.884 2.974-2.884h-.01a6.186 6.186 0 0 1-4.169-1.581 6.02 6.02 0 0 0-1.987 4.486c.011 3.356 2.778 6.066 6.183 6.057a6.202 6.202 0 0 0 3.933-1.412l.006-.005c.043-.036 1.48-1.325 2.837-2.54l-2.404-2.13M34.358 23.036l2.505-2.23a2.984 2.984 0 0 1 1.886-.654c1.641 0 2.974 1.295 2.974 2.884h3.19c0-3.355-2.762-6.073-6.166-6.073a6.2 6.2 0 0 0-3.94 1.401l-.005.005c-.043.036-1.485 1.32-2.846 2.533l2.396 2.137.006-.003Z"
        />
        <path
          fill="url(#klubExclusiveIcon-c)"
          d="M240 3.998a4 4 0 0 0-4.001-4c-51.64.012-103.28 0-154.92.002-13.298 0-24.078 10.744-24.078 23.999 0 13.254 10.78 23.999 24.078 23.999 51.641-.001 103.281-.003 154.921-.002a4 4 0 0 0 4-4V3.998Z"
        />
        <path
          fill="#BC2C1C"
          d="M66.287 5.063c5.912 4.391 9.714 11.24 9.714 18.936s-3.803 14.546-9.715 18.938C60.635 38.545 57 31.695 57 24c0-7.696 3.635-14.546 9.286-18.938Z"
        />
        <path
          fill="#fff"
          d="M96 31.744V16.278h10.006v2.755h-6.649v3.632h6.256v2.692h-6.256v3.61h7.041v2.777H96ZM108.382 31.744l5.101-7.797-4.861-7.67h3.749l3.226 5.234 3.27-5.233h3.488l-4.927 7.647 5.188 7.819h-3.88l-3.444-5.148L112 31.744h-3.618ZM131.423 32c-5.231 0-7.28-3.033-7.28-7.818 0-4.914 2.659-8.182 7.607-8.182 3.532 0 6.039 1.666 6.213 5.554l-3.074.256c-.196-2.2-1.155-3.097-3.182-3.097-2.572 0-4.098 1.623-4.098 5.298 0 3.802 1.373 5.276 3.858 5.276 2.267 0 3.052-1.153 3.422-2.777l3.03.513c-.501 3.695-3.662 4.977-6.496 4.977ZM141.392 31.744V16.278h3.357v12.689h6.758v2.777h-10.115ZM160.957 32c-4.36 0-6.213-1.88-6.213-5.917v-9.805h3.379v9.356c0 2.414.632 3.61 2.965 3.61 2.223 0 2.877-1.025 2.877-3.546v-9.42h3.357v9.89c0 4.102-2.42 5.832-6.365 5.832ZM176.412 32c-2.834 0-5.82-.897-6.103-4.913l3.051-.449c.262 1.495.829 2.756 3.139 2.756 1.396 0 2.616-.47 2.616-1.901 0-1.367-1.482-1.773-3.204-2.2-2.311-.577-5.014-1.282-5.014-4.636 0-3.012 2.572-4.657 5.755-4.657 2.812 0 5.384.855 5.624 4.529l-3.074.341c-.13-1.452-.741-2.328-2.594-2.328-1.613 0-2.354.662-2.354 1.645 0 1.388 1.504 1.816 3.248 2.286 2.311.62 4.948 1.388 4.948 4.635 0 3.503-2.899 4.892-6.038 4.892ZM185.975 31.744V16.278h3.357v15.466h-3.357ZM197.305 31.744l-5.122-15.466h3.771l3.597 12.219h.13l3.597-12.22h3.466l-4.905 15.467h-4.534ZM209.602 31.744V16.278h10.006v2.755h-6.649v3.632h6.256v2.692h-6.256v3.61H220v2.777h-10.398Z"
        />
      </g>
      <defs>
        <linearGradient
          id="klubExclusiveIcon-b"
          x1={0}
          x2={76}
          y1={28.432}
          y2={28.432}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BD2414" />
          <stop offset={1} stopColor="#DD3422" />
        </linearGradient>
        <linearGradient
          id="klubExclusiveIcon-c"
          x1={57.001}
          x2={235.046}
          y1={23.998}
          y2={-5.701}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B292E" />
          <stop offset={1} stopColor="#5A575C" />
        </linearGradient>
        <clipPath id="klubExclusiveIcon-a">
          <path fill="#fff" d="M0 0h240v48H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KlubExclusiveIcon;
